if(!global["blueimp"]) global["blueimp"] = {};
module.exports = global["blueimp"]["Gallery"] = require("-!./blueimp-gallery.js");